import styled from '@emotion/styled'

export const StyledHeader = styled.span`
  font-weight: 500;
  font-size: 14px;
`

export const StyledButton = styled.span`
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
`

export const StyledPastSO = styled.span`
  font-weight: 400;
  font-size: 13px;
`

export const PastSOContainer = styled.div(
  ({ isOpen, height }: { isOpen: boolean; height: number }) => ({
    overflow: 'hidden',
    transition: 'max-height 0.4s ease, opacity 0.4s ease',
    opacity: isOpen ? 1 : 0,
    maxHeight: isOpen ? `${height}px` : '0'
  })
)
